import { useEffect, useState, useRef, useMemo } from "react";
import SliderBarMaps from "../../../../componentes/easyMaps/sideBarEasyMaps";
import api from "../../../../services/apiPublic";
import {
  Stack,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography,
  useTheme,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useOutletContext, useParams } from "react-router-dom";
import "../../../../componentes/leaflet-migrations";
import "../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import LeafletMapa from "./leaflatMapa";
import { useNavigate } from "react-router-dom";
import AlertModal from "../../../../componentes/alertModal";
import LoadingUpdate from "../../../../componentes/easyMaps/loadingUpdate";
import { MapaContext } from "../../../../contexts/mapaContext";
import getCentroid from "../utils/getCentroid";
import ToastAlert from "../../../../componentes/easyMaps/toastAlert";
import { ToastContainer } from "react-toastify";

export default function MapaGeolocalizadoPublic() {
  const tipo = "easymon";
  const mapRef = useRef();
  const theme = useTheme();
  const [snackbar, setSnackbar] = useState(null);
  const [produtos, setProdutos] = useState(false);
  const [map, setMap] = useState(null);
  const [elements, setElements] = useState([]);
  const [elementSelected, setElementSelected] = useState(null);
  const [connectionSelected, setConnectionSelected] = useState(null);
  const [connections, setConnections] = useState([]);
  const [fullScreem, setFullScreem] = useState(false);
  const [mapas, setMapas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [iconsElements, setIconsElements] = useState([]);
  const [loadingMap, setLoadingMap] = useState(true);
  const [soundState, setSoundState] = useState(false);
  const [newAlerts, setNewAlerts] = useState([]);

  const [sinc, setSinc] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [collapse, setCollapse] = useState(false);

  // atualização otimização
  const [hostsDataMap, setHostsDataMap] = useState(new Map());
  const [alertsDataMap, setAlertsDataMap] = useState(new Map());
  const [connectionsDataMap, setConnectionsDataMap] = useState(new Map());
  const [lastCollectData, setLastCollectData] = useState(null);
  const [configElementDataMap, setConfigElementDataMap] = useState(new Map());
  const [configurationMap, setConfigurationMap] = useState(null);
  const [
    connectionsDataMapPercentTraffic,
    setConnectionsDataMapPercentTraffic,
  ] = useState(new Map());
  const [connectionsDataMapPercentPower, setConnectionsDataMapPercentPower] =
    useState(new Map());
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { id } = useParams();
  const { socket, config, configLayer, setConfigLayer } = useOutletContext();
  const startMapRef = useRef(false);

  const latLngZoomFromUrl = useMemo(() => {
    const url = new URL(window.location.href);
    const latURL = url.searchParams.get("lat");
    const lngURL = url.searchParams.get("lng");
    const zoomURL = url.searchParams.get("zoom");

    const lat = latURL ? Number(latURL) : NaN;
    const lng = lngURL ? Number(lngURL) : NaN;
    const zoom = zoomURL ? Number(zoomURL) : NaN;

    return { lat, lng, zoom };
  }, []);

  const isMobile =
    navigator.userAgentData?.mobile === true ||
    window.matchMedia("(pointer: coarse)").matches;

  const styles = {
    fullScreem: {
      position: "fixed",
      zIndex: 1300,
      width: "100dvw",
      height: "100dvh",
      left: 0,
      top: 0,
      backgroundColor: theme.palette.background.default,
    },
    noFullScreem: {
      position: "relative",
      ml: { xs: "0px", md: collapse ? "0px" : "340px" },
      width: {
        xs: "100dvw",
        md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
      },
      height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
    },
    loadingMap: {
      position: "absolute",
      zIndex: 1000,
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.mode != "dark" ? "#e0e0e093" : "#00000093",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 4,
    },
    toastContainer: {
      zIndex: fullScreem ? 1301 : 1200,
      marginTop: (sinc || loadingMap ? 55 : 0) + (fullScreem ? 0 : 60) + "px",
      marginRight: elementSelected ? "355px" : "0",
    },
  };

  useEffect(() => {
    if (newAlerts.length === 0) return;

    newAlerts.forEach((alert, index) => {
      const element = elements.get(alert.elementId);

      ToastAlert({
        alert,
        focus: (id) => {
          mapRef?.current?.focusZoomExt(id);
        },
        element,
        theme,
        sound: index === 0 && soundState, // Toca o som apenas para o primeiro alerta da lista
      });
    });

    setNewAlerts([]);
  }, [newAlerts]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    if (elementSelected == null || editMode == true) return;

    setElementSelected({
      ...elements?.get(elementSelected.id),
    });
  }, [elements]);

  async function handleApi() {
    try {
      setLoadingMap(true);
      setElementSelected(null);
      setConnectionSelected(null);
      await Promise.all([
        handleApiGetMap(id),
        handleApiGetMaps(),
        handleApiGetElements(id),
        getIconDB(),
      ]);
    } catch (error) {
    } finally {
      setLoadingMap(false);
      startMapRef.current = true;
    }
  }

  useEffect(() => {
    if (!id || !config) return;
    handleApi();
  }, [id, config]);

  useEffect(() => {
    // atualiza as confi de layer do mapa para o default
    if (!configLayer?.[id]) {
      setConfigLayer((configLayer) => ({
        ...configLayer,
        [id]: "trafego",
      }));
    }
    let timeInterval = config?.configuracoes?.geo?.atualizacao || 60000;
    const interval = window.setInterval(() => {
      updateDataElementSocket();
    }, timeInterval);

    return () => window.clearInterval(interval);
  }, [id, config]);

  async function handleApiGetMap(id) {
    try {
      setOpenAlertModal(null);
      const response = await api.post("/easyMaps/public/map/findMapById", {
        mapId: id,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: " Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        if (response.data.tipo != 0) navigate("/easyMaps");
        else {
          const { ConfigMapEasyMaps, ...map } = response.data;
          setMap(map);
          if (ConfigMapEasyMaps) {
            setConfigurationMap(ConfigMapEasyMaps);
          } else {
            //usa a configurações globais
            setConfigurationMap({
              configuracoes: config?.configuracoes?.geo || null,
            });
          }
        }
      }
    } catch (error) {
      console.error(error);
      if (error?.response?.status == 404) navigate("/easyMaps/pages/notFound");
      if (error?.response?.status == 401)
        setOpenAlertModal({
          open: true,
          severity: "error",
          text: "Você não tem permissão para acessar este mapa, solicite permissão ao administrador",
        });
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  const extractInterfaceName = (key) =>
    key?.match(/\[([^\],]+?(?=\s\-|,|\]))/)?.[1];

  const findSelectedInterface = (items) => {
    const selectedItem = items?.find((item) => {
      const key = item.key_?.toLowerCase();
      return (
        key?.includes("inoctets") ||
        key?.replace(/_/g, "").includes("rxpower") ||
        key?.includes("outoctets") ||
        key?.replace(/_/g, "").includes("txpower")
      );
    });
    if (!selectedItem) return "";
    return extractInterfaceName(selectedItem?.key_);
  };

  async function handleApiGetElements(id) {
    try {
      //setLoadingProdutos(true);
      const response = await api.post("/easyMaps/public/element/findMany", {
        mapId: id,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const data = response.data;
        // transforma os elements em MAP
        let elements = new Map(data.responseAlerts.map((el) => [el.id, el]));
        let connections = new Map(data.connections.map((el) => [el.id, el]));

        setElements(elements);
        setConnections(connections);
        updateDataElementSocket();
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function updateDataElementSocket() {
    try {
      setSinc(true);

      socket.emit("getDataElementsMap", { mapId: id }, (response) => {
        setSinc(false);
        if (response.status !== 200) {
          setSnackbar({
            children: "Error: Não foi possível atualizar os elementos",
            severity: "error",
          });
        } else {
          // trnsforma os elements em MAP
          const updatedData = response?.data;
          const newHostsMap = new Map();
          const newAlertsMap = new Map();
          const newConnectionsMap = new Map();
          const configElementMap = new Map();
          let connGroupedByPercentegeTrafego = {};
          let connGroupedByPercentegePotencia = {};
          for (const el of updatedData.elementosResponse) {
            // hosts por elemento
            if (el.hosts?.length) {
              newHostsMap.set(el.id, el.hosts);
            }

            // conexões concatenadas
            for (const conn of el.connections) {
              //trafego
              if (conn?.corTraffic?.label in connGroupedByPercentegeTrafego) {
                connGroupedByPercentegeTrafego[conn?.corTraffic?.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegeTrafego[conn?.corTraffic?.label] = [
                  conn.id,
                ];
              }
              //potencia
              if (conn?.corPower?.label in connGroupedByPercentegePotencia) {
                connGroupedByPercentegePotencia[conn?.corPower?.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegePotencia[conn?.corPower?.label] = [
                  conn.id,
                ];
              }
              newConnectionsMap.set(conn.id, conn);
            }

            // alerts por elemento (ou por host, se preferir)
            if (el.alerts?.length) {
              newAlertsMap.set(el.id, el.alerts);

              // somente os novos
              const newAlerts = el.alerts.filter((alert) => alert.isNew);

              if (newAlerts.length > 0) {
                setNewAlerts((prev) => {
                  const existingKeys = new Set(
                    prev.map((a) => `${a.triggerid}-${a.eventid}`),
                  );

                  const filtered = newAlerts.filter(
                    (a) => !existingKeys.has(`${a.triggerid}-${a.eventid}`),
                  );

                  return [...prev, ...filtered];
                });
              }
            }
            configElementMap.set(el.id, el.config);
          }
          setHostsDataMap(newHostsMap);
          setAlertsDataMap(newAlertsMap);
          setConfigElementDataMap(configElementMap);
          setConnectionsDataMap(newConnectionsMap);
          setLastCollectData(updatedData?.dataColeta || null);

          // conexões agrupadas por percentual
          setConnectionsDataMapPercentTraffic(
            new Map(Object.entries(connGroupedByPercentegeTrafego)),
          );
          setConnectionsDataMapPercentPower(
            new Map(Object.entries(connGroupedByPercentegePotencia)),
          );
        }
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível atualizar: " + error.message,
        severity: "error",
      });
    }
  }

  async function handleApiGetMaps() {
    try {
      const response = await api.get("/easyMaps/public/map/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMapas(
            response.data.map((map) => ({
              nome: map.titulo,
              id: map.id,
              tipo: map.tipo,
            })),
          );
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function getIconDB() {
    try {
      const response = await api.get("/easyMaps/public/img/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const coordinates = [...elements.values()]?.map((el) => {
    return el?.elementConfig?.config?.coordenadas;
  });

  const boundsCoordinates = useMemo(() => {
    if (coordinates.length > 0) {
      return coordinates.map((c) => [Number(c.lat), Number(c.long)]);
    }
    return null;
  }, [coordinates]);

  const centerCoordinates = useMemo(() => {
    if (
      latLngZoomFromUrl.lat &&
      latLngZoomFromUrl.lng &&
      isNaN(latLngZoomFromUrl?.lat) == false &&
      isNaN(latLngZoomFromUrl?.lng) == false
    )
      return [Number(latLngZoomFromUrl.lat), Number(latLngZoomFromUrl.lng)];
    return [-10, -48];
  }, [coordinates]);

  const handleFullscreen = (value) => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };

  // const testAlert = () => {
  //   setNewAlerts((prev) => [
  //     ...prev,
  //     {
  //       triggerid: Math.random().toString(),
  //       severity: Math.floor(Math.random() * 5) + 1,
  //       description:
  //         "Queda Abrupta na GPON 0/1 Devido a Queda de Energia (Dying-Gasp)! | ONUs Online: {ITEM.VALUE4} | ONUs Offline: {ITEM.VALUE2}",
  //       lastchange: 1773137585,
  //       hostid: "11266",
  //       eventid: "7018711",
  //       event_name:
  //         "Queda Abrupta na GPON 0/1 Devido a Queda de Energia (Dying-Gasp)! | ONUs Online: 31 | ONUs Offline: 18",
  //       itemid: "134495",
  //       key_: "onuDyingGasp[0/1]",
  //       isNew: false,
  //       elementId: "89713fa0-9bc1-4625-8be3-6f7aec1acff4",
  //     },
  //   ]);
  // };

  return (
    <MapaContext.Provider
      value={{
        mapId: id,
        tipo: "geo",
        elements,
        elementSelected,
        setElementSelected,
        connectionSelected,
        setConnectionSelected,
        connections,
        editMode,
        snackbar,
        setSnackbar,
        updateDataElementSocket,
        isPublic: true,
        mapRef,
        hostsDataMap,
        alertsDataMap,
        connectionsDataMap,
        configElementDataMap,
        lastCollectData,
        configurationMap,
        setConfigurationMap,
        connectionsDataMapPercentTraffic,
        connectionsDataMapPercentPower,
        startMapRef,
        soundState,
        setSoundState,
      }}
    >
      {/* <Button
        variant="contained"
        color="secondary"
        onClick={testAlert}
        style={{ position: "absolute", zIndex: 1301, right: 20, top: 20 }}
      >
        {(sinc || loadingMap ? 55 : 0) + (fullScreem ? 0 : 60)}
      </Button> */}
      <ToastContainer
        style={styles.toastContainer}
        newestOnTop
        limit={isMobile ? 4 : 5}
      />
      <Stack direction="row">
        {!fullScreem && (
          <SliderBarMaps
            map={map}
            iconsElements={iconsElements}
            mapRef={mapRef}
            elements={elements}
            collapse={collapse}
            handleCollapse={handleCollapse}
            isPublic={true}
          />
        )}

        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {loadingMap && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" />
              <Typography
                fontSize="14px"
                color={theme.palette.color.textEasyMaps}
              >
                Carregando dados do mapa...
              </Typography>
            </Box>
          )}
          <LoadingUpdate
            visible={sinc && !loadingMap}
            elementSelected={!!elementSelected}
          />

          <LeafletMapa
            setFullScreem={handleFullscreen}
            fullScreem={fullScreem}
            socketCliente={socket}
            ref={mapRef}
            iconsElements={iconsElements}
            setIconsElement={setIconsElements}
            title={map?.titulo}
            element={editMode ? elementSelected : null}
            produtos={produtos}
            api={api}
            setSnackbar={setSnackbar}
            mapas={mapas}
            setMapas={setMapas}
            setEditMode={() => {}}
            updateDataElementSocket={updateDataElementSocket}
            centerCoordinates={centerCoordinates}
            boundsCoordinates={boundsCoordinates}
            latLngZoomFromUrl={latLngZoomFromUrl}
            collapse={collapse}
          />
        </Stack>
      </Stack>
      <AlertModal
        openModal={openAlertModal?.open ?? false}
        setOpenModal={(data) => setOpenAlertModal({ open: data })}
        severity={openAlertModal?.severity}
        textContent={openAlertModal?.text}
        buttonText={openAlertModal?.buttonText || "Voltar"}
        handleButton={() => {
          setOpenAlertModal({ open: false });
          navigate(-1);
        }}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
    </MapaContext.Provider>
  );
}
